import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'

import type {
  MidYearAggregationHomepageData,
  MidYearAggregationShareHomepageData,
} from './service'

type GetHomepageParams = {
  is_need_pop?: boolean
}

export const getHomepage = createAsyncThunk<
  MidYearAggregationHomepageData,
  GetHomepageParams | void
>('MidYearAggregation/getHomepage', async (params, store: any) => {
  const resp = await http.post(
    '/live/activity/mid_year_aggregation_homepage',
    {...(params ?? {is_need_pop: false})},
    {
      store,
    }
  )
  return resp.data?.data as MidYearAggregationHomepageData
})

export const getShareHomepage = createAsyncThunk(
  'MidYearAggregation/getShareHomepage',
  async (_, store: any) => {
    const resp = await http.post(
      '/live/activity/mid_year_aggregation_share_homepage',
      {},
      {
        store,
      }
    )
    return resp.data?.data as MidYearAggregationShareHomepageData
  }
)

const initialState: {
  homepage: MidYearAggregationHomepageData
  shareHomepage: MidYearAggregationShareHomepageData
} = {
  homepage: {},
  shareHomepage: {},
}

export const MidYearAggregationSlice = createSlice({
  name: 'MidYearAggregation',
  initialState,
  reducers: {
    updateHomepage: (
      state,
      action: {payload: Partial<MidYearAggregationHomepageData>}
    ) => {
      Object.assign(state.homepage, action.payload)
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getHomepage.fulfilled, (state, action) => {
        Object.assign(state.homepage, action.payload)
      })
      .addCase(getShareHomepage.fulfilled, (state, action) => {
        Object.assign(state.shareHomepage, action.payload)
      })
  },
})

export const MidYearAggregationActions = MidYearAggregationSlice.actions

export default MidYearAggregationSlice.reducer
